import React, { useId, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface AnimatedInputProps extends React.ComponentProps<"input"> {
  label: string;
  id?: string;
}

export const AnimatedInput = forwardRef<HTMLInputElement, AnimatedInputProps>(({ 
  label, 
  className, 
  id: providedId, 
  ...props 
}, ref) => {
  const generatedId = useId();
  const id = providedId || generatedId;
  
  return (
    <div className="group relative">
      <label
        htmlFor={id}
        className="origin-start text-muted-foreground/70 group-focus-within:text-foreground has-[+input:not(:placeholder-shown)]:text-foreground absolute top-1/2 block -translate-y-1/2 cursor-text px-1 text-sm transition-all group-focus-within:pointer-events-none group-focus-within:top-0 group-focus-within:cursor-default group-focus-within:text-xs group-focus-within:font-medium has-[+input:not(:placeholder-shown)]:pointer-events-none has-[+input:not(:placeholder-shown)]:top-0 has-[+input:not(:placeholder-shown)]:cursor-default has-[+input:not(:placeholder-shown)]:text-xs has-[+input:not(:placeholder-shown)]:font-medium"
      >
        <span className="bg-background inline-flex px-2">{label}</span>
      </label>
      <Input 
        id={id} 
        ref={ref}
        placeholder=" " 
        className={cn(
          "border-input focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          className
        )}
        {...props} 
      />
    </div>
  );
});

AnimatedInput.displayName = "AnimatedInput";
